module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Undo-022b062f4d2e7082e202c8537805b9c2.svg";